import { ImageEdit, QuillEditor } from "@pathwright/blocks/src/shared"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { TOOLBAR_CONFIG_TYPES } from "@pathwright/ui/src/components/quill/toolbar/QuillToolbar"
import { AutoWidthCol, Col, TextBackgroundWrapper } from "./ui"

const Image = (props) => {
  const { layout, data, onChange, blockStyles } = props

  const imageProps = {
    image: data.src,
    altText: data.altText,
    caption: data.caption,
    blockStyles,
    annotations: data.annotations || [],
    onChangeImage: (image, altText) =>
      onChange({
        ...data,
        src: image,
        altText: altText || "Image block"
      }),
    onChangeCaption: (caption) => onChange({ ...data, caption }),
    onChangeAnnotations: (annotations) => {
      annotations = annotations.map((annotation) => {
        return {
          ...annotation,
          xPos: parseFloat(annotation.xPos),
          yPos: parseFloat(annotation.yPos)
        }
      })
      onChange({ ...data, annotations })
    }
  }

  if (layout === "fullwidth") {
    return <ImageEdit {...imageProps} captionEnabled />
  }

  // Legacy block layout
  if (layout === "center") {
    return (
      <Content.Container>
        <ImageEdit {...imageProps} captionEnabled />
      </Content.Container>
    )
  }

  if (layout === "annotated") {
    return (
      <div>
        <ImageEdit {...imageProps} annotationsEnabled captionEnabled />
      </div>
    )
  }

  if (layout === "text") {
    return (
      <Content.Container style={{ display: "flex", flexWrap: "wrap" }}>
        <AutoWidthCol>
          <ImageEdit {...imageProps} />
        </AutoWidthCol>
        <Col
          style={{
            minWidth: 300,
            padding: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
          }}
        >
          <QuillEditor
            toolbar={TOOLBAR_CONFIG_TYPES.ADVANCED}
            html={data.text}
            onChange={(text) => onChange({ ...data, text })}
          />
        </Col>
      </Content.Container>
    )
  }

  if (layout === "text_background") {
    return (
      <TextBackgroundWrapper textColor="white">
        <ImageEdit {...imageProps} backgroundMode />
        <Content.Container style={{ position: "relative" }}>
          <QuillEditor
            html={data.text}
            onChange={(text) => onChange({ ...data, text })}
            toolbar={TOOLBAR_CONFIG_TYPES.ADVANCED}
            inverted
          />
        </Content.Container>
      </TextBackgroundWrapper>
    )
  }

  return null
}

export default Image
